import classNames from 'classnames'

import { RequestMultiValuedListItem } from '../../../../../../Request'

import * as styles from './ListItem.module.css'

function ListItem({ className, ...restProps }) {
  const classNameListItem = classNames(className, styles.listItem)

  return (
    <RequestMultiValuedListItem {...restProps} className={classNameListItem} />
  )
}

export default ListItem
